import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { FormattedMessage } from 'react-intl'

import style from './workout.module.scss'
import WorkoutScroll from '../workout-scroll/workout-scroll'

/**
 * Render Preview on Program screen.
 */
const Workout = ({ workoutImages, workouts, programId, color }) => (
    <div className={cn(style.workoutWrapper, 'page-wrapper')}>
        {/* This will be available in the next version. Keep it here
            <h1 className="gym-h6 gym-h--primary">
                <FormattedMessage id="program.workout.title" />
            </h1>

            <div className={style.description}>
                <FormattedMessage id="program.workout.description" />
            </div>
        */}

        <div className={cn('gym-h', style.workoutsTotal)} style={{ color }}>
            <FormattedMessage
                id="program.workout.programs"
                values={{ total: workouts.totalElements }}
            />
        </div>

        <WorkoutScroll
            programId={programId}
            workouts={workouts}
            workoutImages={workoutImages}
        />
    </div>
)

Workout.propTypes = {
    programId: PropTypes.number.isRequired,
    workoutImages: PropTypes.arrayOf(PropTypes.object).isRequired,
    workouts: PropTypes.object.isRequired,
    color: PropTypes.string.isRequired,
}

export default Workout
